// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3127":"de50ac5a","7904":"6a4610d4","8262":"2ba1de4b"}[chunkId] + ".chunk.css";
};